import { useSelector } from 'react-redux';
import { useAsyncValue } from 'reactApp/hooks/useAsyncValue';
import { getHasCardFlag, HAS_CARD_FLAG_SYNC_STORAGE_KEY } from 'reactApp/modules/creditCard/creditCard.flags';
import { CardSelectors } from 'reactApp/modules/creditCard/creditCard.selectors';
import { safetyPersonalLocalStorage } from 'reactApp/storage';

interface HasCardFlagState {
    hasCard: boolean;
    isLoaded: boolean;
}

export const useHasCardFlag = (enabled: boolean): HasCardFlagState => {
    const { isLoaded: isCardLoaded, hasError: hasCardError } = useSelector(CardSelectors.getCard);
    const isHasCardFlagSyncDone = safetyPersonalLocalStorage.getItem(HAS_CARD_FLAG_SYNC_STORAGE_KEY) === 'true';
    const { data: hasCard, isLoaded } = useAsyncValue(
        () => {
            if (!enabled) {
                return Promise.resolve(false);
            }

            return getHasCardFlag().catch(() => true);
        },
        false,
        [enabled, isCardLoaded]
    );

    if (!enabled) {
        return { hasCard, isLoaded: true };
    }

    if (!isLoaded) {
        return { hasCard, isLoaded: false };
    }

    if (isHasCardFlagSyncDone) {
        return { hasCard, isLoaded: true };
    }

    return { hasCard, isLoaded: isCardLoaded && !hasCardError };
};
